export default __webpack_public_path__ + "static/media/per-indeed.8efeeab9.svg";